export const HOME_PAGE_ROUTE = "/";
export const LOGIN_PAGE_ROUTE = "/login";
export const DASHBOARD_PAGE_ROUTE = "/dashboard";
export const ADMIN_PAGE_ROUTE = "/admin";
export const RBAC_PAGE_ROUTE = "/rbac";
export const CONTACT_PAGE_ROUTE = "/contact";
export const DEPLOYMENTS_PAGE_ROUTE = "/deployments";
export const APPROVAL_PAGE_ROUTE = "/approval";
export const BILLING_PAGE_ROUTE = "/billing";
export const EVENTS_PAGE_ROUTE = "/events"

